export enum JazzmoCustomPath {
  search = 'search',
  newsletter = 'newsletter',
}
